// Module
var code = "<div class=\"jh-header\"> <h1>Fx Wire Entitlements</h1> <div class=\"inline-grouping inline-grouping-right\"></div> </div> <div ng-init=\"productType = 'WireTransferDLI'\"> <div ng-controller=\"WireTransfersEntitlementsController\" ng-include=\"'app/company/profile/userInfo/views/wireTransferEntitlementsForm.html'\"></div> </div> ";
// Exports
module.exports = code;